/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

export const EvalScheduleOverlapPolicy = {
  Skip: "skip",
  BufferOne: "buffer_one",
  AllowAll: "allow_all",
} as const;
export type EvalScheduleOverlapPolicy = ClosedEnum<
  typeof EvalScheduleOverlapPolicy
>;

/** @internal */
export const EvalScheduleOverlapPolicy$inboundSchema: z.ZodNativeEnum<
  typeof EvalScheduleOverlapPolicy
> = z.nativeEnum(EvalScheduleOverlapPolicy);
/** @internal */
export const EvalScheduleOverlapPolicy$outboundSchema: z.ZodNativeEnum<
  typeof EvalScheduleOverlapPolicy
> = EvalScheduleOverlapPolicy$inboundSchema;
